import { render, staticRenderFns } from "./ObjectList.vue?vue&type=template&id=edd9edec&scoped=true&"
import script from "./ObjectList.vue?vue&type=script&lang=js&"
export * from "./ObjectList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd9edec",
  null
  
)

export default component.exports